import './app.css';

import { useState } from 'react';
import {
  Attribute,
  ZakekeEnvironment,
  ZakekeProvider,
  ZakekeViewer,
} from 'zakeke-configurator-react';

import BoxInfoOrbit3d from './components/BoxInfoOrbit3d/BoxInfoOrbit3d';
import { ConfiguratorProvider } from './components/ConfiguratorWizard/ConfiguratorContext';
import ConfiguratorWizard from './components/ConfiguratorWizard/ConfiguratorWizard';
import { Product } from './components/ProductCard/ProductCard';
import ProductSummary from './components/ProductSummary/ProductSummary';
import VariantsSelector from './components/VariantsSelector/VariantsSelector';
import { OthersInfo, SelectedInformation } from './interfaces';

const zakekeEnvironment = new ZakekeEnvironment();

export default function App() {
  const [hasInteracted, setHasInteracted] = useState(false);
  const [showConfigurator, setShowConfigurator] = useState(false);
  const [selectedInformation, setSelectedInformation] =
    useState<SelectedInformation | null>(null);

  const [attributes, setAttributes] = useState<Attribute[]>([]);

  const handleViewerInteraction = () => {
    setHasInteracted(true);
  };

  return (
    <ZakekeProvider environment={zakekeEnvironment}>
      <ConfiguratorProvider>
        <ConfiguratorWizard
          onComplete={(product: Product, othersInfo: OthersInfo) => {
            setSelectedInformation({ product, othersInfo });
            setShowConfigurator(showConfigurator);
          }}
          onShowConfigurator={(val) => setShowConfigurator(val)}
        />
        {showConfigurator && selectedInformation && (
          <div className="zakeke-viewer">
            <VariantsSelector onAttributesChange={setAttributes} />
            <div className="viewer-container">
              <div
                className="viewer-container--render"
                onPointerDown={handleViewerInteraction}
                onWheel={handleViewerInteraction}
                onTouchStart={handleViewerInteraction}
                onTouchMove={handleViewerInteraction}
              >
                <ZakekeViewer /> {!hasInteracted && <BoxInfoOrbit3d />}
              </div>

              <ProductSummary
                attributes={attributes}
                othersInfo={selectedInformation.othersInfo}
                product={selectedInformation.product}
              />
            </div>
          </div>
        )}
      </ConfiguratorProvider>
    </ZakekeProvider>
  );
}
